"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ObjectTypes = require("./ObjectTypes");

var _COMPANY$CONTACT$DEAL;

var _default = (_COMPANY$CONTACT$DEAL = {}, (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.COMPANY, ['companyId']), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.CONTACT, ['vid']), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.DEAL, ['dealId']), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.ENGAGEMENT, ['engagement', 'id']), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.FEEDBACK_SUBMISSION, ['objectId']), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.LINE_ITEM, ['objectId']), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.LIST, ['listId']), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.PRODUCT, ['objectId']), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.QUOTE, ['objectId']), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.TASK, ['engagement', 'id']), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.TICKET, ['objectId']), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.VISIT, ['domain']), _COMPANY$CONTACT$DEAL);

exports.default = _default;
module.exports = exports.default;